const API_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Track user interactions on the website
 * @param {string} eventType - Type of event (contact_form, calendly_open, cta_click, project_view, etc.)
 * @param {string} eventName - Name/description of the event
 * @param {string} page - Page where event occurred
 * @param {object} metadata - Additional data about the event
 */
export const trackEvent = async (eventType, eventName, page, metadata = null) => {
  try {
    await fetch(`${API_URL}/api/events/track`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        event_type: eventType,
        event_name: eventName,
        page: page,
        metadata: metadata,
      }),
    });
  } catch (error) {
    // Silent fail - don't break UX for analytics
    console.error('Analytics tracking error:', error);
  }
};

// Predefined event types
export const EventTypes = {
  CONTACT_FORM: 'contact_form',
  CALENDLY_OPEN: 'calendly_open',
  CTA_CLICK: 'cta_click',
  PROJECT_VIEW: 'project_view',
  PAGE_VIEW: 'page_view',
  SEARCH: 'search',
  NAVIGATION: 'navigation',
};

export default trackEvent;
